import { code } from "@spscommerce/utils";

export const SpsFeedbackBlockExamples = {
    demos: {
        examples: {
            tip: {
                template: code`
              <sps-feedback-block kind="tip">
                Please Note: Click the Receive button above to check for new transactions from QuickBooks.
                <br/>
                Please Note: Click the Receive button above to check for new transactions from QuickBooks.
              </sps-feedback-block>
            `
            },
            success: {
                template: code`
              <sps-feedback-block kind="success">
                All items have been uploaded and are ready for export.
              </sps-feedback-block>
            `
            },
            info: {
                template: code`
              <sps-feedback-block kind="info">
                FYI— This page has been updated. Click refresh to see the most recent version.
              </sps-feedback-block>
            `
            },
            warning: {
                template: code`
              <sps-feedback-block kind="warning">
                Warning! This order is missing a shipment date and is in jeopardy of being past due.
              </sps-feedback-block>
            `
            },
            error: {
                template: code`
              <sps-feedback-block kind="error">
                We are experiencing difficulties communicating to the server. Please try again later.
              </sps-feedback-block>
            `
            }
        }
    }
};
